/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  report(id) {
    return axios.get(`${this.url}/${id}/report`);
  }

  audienceCount(audience) {
    return axios.post(`${this.url}/audience_count`, { audience });
  }
}

export default new CampaignsAPI();
